import GeneralPrecheckout from './GeneralPrecheckout';
import { GeneralPrecheckoutProps, GeneralPrecheckoutValueProps } from './types';

export type { GeneralPrecheckoutProps, GeneralPrecheckoutValueProps };
export default GeneralPrecheckout;
